import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { Note } from '@care-portals/api-interfaces';
import { formTypes } from '@care-portals/data';
import { NameAvatarComponent } from '../note-avatar/note-avatar.component';
import { RouterModule } from '@angular/router';
import { getOrgAwareMenuQueryParams } from '../../../../+store/app/layout-org.util';

@Component({
  selector: 'portals-provider-note-item',
  templateUrl: './note-item.component.html',
  styleUrls: ['./note-item.component.less'],
  standalone: true,
  imports: [CommonModule, NameAvatarComponent, RouterModule]
})
export class NoteItemComponent implements OnInit {
  @Input() note: Note;
  types: { [key: string]: string } = {};
  getOrgAwareMenuQueryParams = getOrgAwareMenuQueryParams;
  constructor() { }

  ngOnInit() {
    Object.keys(formTypes).map(
      type => (this.types[type] = formTypes[type].name)
    );
  }
}
